import Vue from 'vue';
import clientGroupTransformer from './../../transformers/clientGroup';
import store from './../../store';

const success = ({ data }) => clientGroupTransformer.fetch(data);

const failed = (error, reject) => reject(error);

export default id => (
  new Promise((resolve, reject) => {
    const clientGroups = store.state.clientGroup.items.filter(c => (
      c.id.toString() === id.toString()
    ));

    if (clientGroups.length > 0) {
      return resolve(clientGroups[0]);
    }

    return Vue.$http.get(`/client_groups/${id}`)
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/client-group/show.js